import { render, staticRenderFns } from "./CateogriesCard.vue?vue&type=template&id=bbb9c0aa&"
import script from "./CateogriesCard.vue?vue&type=script&lang=js&"
export * from "./CateogriesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports